import { render, staticRenderFns } from "./ChatApp.vue?vue&type=template&id=66f51410&scoped=true"
import script from "./ChatApp.vue?vue&type=script&lang=js"
export * from "./ChatApp.vue?vue&type=script&lang=js"
import style0 from "./ChatApp.vue?vue&type=style&index=0&id=66f51410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f51410",
  null
  
)

export default component.exports